<template>
  <div class="page">
    <Navbar />
    <Banner
      :hasPosition="true"
      :hasText="true"
      :hasLogo="true"
      :haSingleImg="true"
      :text="titulos[0]"
      :logo="require('@/assets/logo.png')"
      :imagem="require('@/assets/img/home/banner.jpg') "
    />
    <v-container class="pt-0">
      <v-col>
        <v-row class="d-flex justify-center mt-12">
          <span class="display-1">{{titulos[1]}}</span>
        </v-row>

        <v-row>
          <Cards
            type="roteiro"
            :iSingle="false"
            :informations="roteirosDest"
            :btnText="titulos[4]"
          />
        </v-row>

        <v-row class="d-flex justify-center mb-10">
          <span class="display-1">{{titulos[2]}}</span>
        </v-row>

        <v-row>
          <Cards
            type="noticia"
            :iSingle="false"
            :informations="noticiasDest"
            :btnText="titulos[4]"
          />
        </v-row>

        <v-row class="d-flex justify-center my-10">
          <span class="display-1">{{titulos[3]}}</span>
        </v-row>

        <v-row>
          <Cards type="evento" :iSingle="false" :informations="eventosDest" :btnText="titulos[4]" />
        </v-row>

        <v-row>
          <v-col class="d-flex justify-center flex-column align-center my-1">
            <span class="display-1 my-10">{{titulos[5]}}</span>
            <div class="body-1">{{titulos[6]}}</div>
            <div class="body-1 mb-10">{{titulos[7]}}</div>
            <v-row>
              <v-btn
                href="https://appdistribution.firebase.dev/i/ApbRkNzJ"
                class="mr-5"
                dark
                large
                color="green"
              >
                <v-icon dark>mdi-android</v-icon>
              </v-btn>
              <v-btn
                href="https://appdistribution.firebase.dev/i/uSysf7wC"
                dark
                large
                color="black"
              >
                <v-icon dark>mdi-apple</v-icon>
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-container>
    <Footer/>
  </div>
</template>

<script>
import { getLangValue } from "@/globalFunctions.js";
import Navbar from "@/components/Navbar.vue";
import Banner from "@/components/Banner.vue";
import Cards from "@/components/Cards.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "Home",
  components: {
    Navbar,
    Banner,
    Cards,
    Footer
  },
  async mounted() {
    await this.putTitulos();

    var roteiros = await this.$store.dispatch("setRoteiros");
    var noticias = await this.$store.dispatch("setNoticias");
    var eventos = await this.$store.dispatch("setEventos");

    this.roteirosDest = roteiros.roteirosDest;
    this.noticiasDest = noticias.noticiasDest;
    this.eventosDest = eventos.eventosDest;
  },
  data: () => ({
    titulos: [],
    hasScroll:null,
    roteirosDest: [],
    noticiasDest: [],
    eventosDest: []
  }),
  methods: {
    putTitulos: async function() {
      var homeDescricao = await getLangValue(
        "Home",
        "Descricao",
        this.$store.getters.language
      );
      var homeRoteiros = await getLangValue(
        "Home",
        "Roteiros",
        this.$store.getters.language
      );

      var homeNoticias = await getLangValue(
        "Home",
        "Noticias",
        this.$store.getters.language
      );

      var homeEventos = await getLangValue(
        "Home",
        "Eventos",
        this.$store.getters.language
      );

      var homeAbrir = await getLangValue(
        "Home",
        "Abrir",
        this.$store.getters.language
      );

      var homeApp = await getLangValue(
        "Home",
        "App",
        this.$store.getters.language
      );

      var homeAppDesc1 = await getLangValue(
        "Home",
        "AppDesc1",
        this.$store.getters.language
      );

      var homeAppDesc2 = await getLangValue(
        "Home",
        "AppDesc2",
        this.$store.getters.language
      );

      this.titulos.push(homeDescricao);
      this.titulos.push(homeRoteiros);
      this.titulos.push(homeNoticias);
      this.titulos.push(homeEventos);
      this.titulos.push(homeAbrir);
      this.titulos.push(homeApp);
      this.titulos.push(homeAppDesc1);
      this.titulos.push(homeAppDesc2);
    },
    goTo(routeName, id) {
      var lang = "/" + this.$store.getters.language + "/";
      this.$router.push({ path: lang + routeName + id });
    }
  }
};
</script>
